import React from "react";
import { ActivityModule } from "../../../constants/Module";
import CreatorDetails from "./creatorDetails";
import { withTranslation } from "react-i18next";

const AddMilestoneBudget = ({ item, t }) => {

    return (
        <React.Fragment>
            <div className="mx-2">
                {item?.module === ActivityModule.MILESTONE_BUDGET &&
                    <div>
                        <strong>{t('Milestone Budget')} ({item?.payload?.budgetType}) </strong>
                        {t('was created for')} <strong>{t('milestone')} ({item?.payload?.milestone?.name})</strong> {t('from')} <strong>{t('change request')} ({item?.payload?.changeRequest?.uniqueChangeRequestId})</strong> {t('to')} <strong>{t('startup')} ({item?.payload?.project?.uniqueProjectId})</strong>
                        <CreatorDetails creator={item?.creator} date={item?.createdAt} />
                    </div>
                }
            </div>
        </React.Fragment>
    )
}
export default withTranslation()(AddMilestoneBudget);
